import React, { Component } from "react"

export default class Select extends Component {
  render() {
    return (
      <div className="input-group">
        <span className="input-group-addon">
          <i className="material-icons">{this.props.icon}</i>
        </span>
        <div className="form-group label-floating is-empty">
          <label className="control-label">{this.props.label}</label>
          <select
            className="form-control"
            name={this.props.name}
            onChange={this.props.onChange}
          >
            {this.props.options.map((value, key) => {
              return (
                <option key={key} value={value.value}>
                  {value.label}
                </option>
              )
            })}
          </select>
          <span className="label label-danger" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Select.js